import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { GoalsPage } from "@/features/goals/GoalsPage";

const search = z.object({
  level: z.enum(["all", "agency", "team", "person"]).optional(),
});

export const Route = createFileRoute("/_app/goals")({
  validateSearch: search,
  component: () => <GoalsPage search={Route.useSearch()} />,
});
